import { buildPositionChangeData } from './buildPositionChangeData';
import type { PositionChangeData, WaypointPosition } from './types';

/**
 * Handles all callbacks based on position changes
 */
export function handleCallbacks(params: {
	inView: boolean;
	entry: IntersectionObserverEntry;
	currentPosition: WaypointPosition;
	previousPosition: WaypointPosition | undefined;
	onEnter?: () => void;
	onLeave?: () => void;
	onPositionChange?: (data: PositionChangeData) => void;
	horizontal?: boolean;
}): void {
	const { inView, entry, currentPosition, previousPosition, onEnter, onLeave, onPositionChange, horizontal } = params;

	// Call position change callback
	if (onPositionChange) {
		const positionData = buildPositionChangeData({
			entry,
			currentPosition,
			previousPosition,
			horizontal,
		});
		onPositionChange(positionData);
	}

	// Call enter/leave callbacks
	if (inView && onEnter) {
		onEnter();
	} else if (!inView && onLeave) {
		onLeave();
	}
}
